/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */

/* Utils */
import withInteractiveFocusable from '../../../../hocs/withInteractiveFocusable.hoc';

/* Styles */
import './AgeRatingProgressSteps.scss';

export function BaseFocusableAgeRating({
  className,
  focused,
  label,
  styleStep,
  changeActiveStep,
  step,
}) {
  return (
    <button
      type="button"
      className={`age-rating-steps-html5__container-wrapper ${focused ? 'age-rating-steps-html5__container-wrapper--focused' : ''}`}
    >
      <div className="age-rating-steps-html5__container-label-container">
        {label}
      </div>
      <div className={`age-rating-steps-html5__container-background ${className}`} style={styleStep}>
        {step <= changeActiveStep && <div className="age-rating-steps-html5__container-circle" /> }
      </div>
    </button>
  );
}

BaseFocusableAgeRating.propTypes = {
  className: PropTypes.string,
  focused: PropTypes.bool.isRequired,
  label: PropTypes.shape({}),
  styleStep: PropTypes.shape({}),
  changeActiveStep: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  step: PropTypes.number.isRequired,
};

BaseFocusableAgeRating.defaultProps = {
  className: '',
  label: {},
  styleStep: {},
};

export default memo(withInteractiveFocusable()(memo(BaseFocusableAgeRating)));
